import React, { useEffect, useState } from 'react'
// Components
import { Text } from 'components/Text/Text'
// Styles
import { useKeypress } from 'hooks/use-keypress'
import { ModalProps } from 'components/Modal'
import { ModalClose, ModalContainer, ModalRoot, ModalTitle } from 'components/Modal/Modal.styled'
import { ReservationModalButton, ReservationModalContainer, ReservationModalContent, ReservationModalDes, ReservationModalFooter } from './ReservationModalDelete.styled'

interface ReservationModalDeleteProps extends ModalProps {
    onConfirm: () => void
}

export const ReservationModalDelete = ({
  children,
  rootStyle,
  containerStyle = {
    'maxWidth': '500px',
  },
  typeModal,
  showClose = true,
  title,
  onClose,
  onConfirm,
}: ReservationModalDeleteProps) => {
  
    const [esc, setEsc] = useState(false)
    useKeypress('Escape', () => setEsc(true))
    useEffect(() => {
        if (showClose && esc && onClose) {
            setEsc(false)
            onClose()
        }
    }, [esc, showClose, onClose])

    return (
        <ReservationModalContainer showClose title='Confirmation' onClose={onClose} containerStyle={containerStyle}>
            <ReservationModalContent>
                <ReservationModalDes>
                    Are you sure you would like to cancel this appointment?
                </ReservationModalDes>
                <ReservationModalFooter>
                    <ReservationModalButton
                    size="medium"
                    text="Cancel"
                    variant="secondary"
                    preset="filled"
                    onClick={onClose}
                    />
                    <ReservationModalButton
                    size="medium"
                    text="Ok"
                    variant="primary"
                    preset="filled"
                    onClick={onConfirm}
                    />
                </ReservationModalFooter>
            </ReservationModalContent>
        </ReservationModalContainer>
  )
}

export default ReservationModalDelete;